import { FC } from 'react'
import Icon from './Icon'
import { ContentBlock } from '@libs/types/generated/housing-market-ui'
import TextContent from './TextContent'

interface Props {
  geo: string
  summary: ContentBlock
  buyerText: ContentBlock
  sellerText: ContentBlock
}
const BuyerSeller: FC<Props> = ({
  geo,
  summary = { content: [], header: '' },
  buyerText = { content: [] },
  sellerText = { content: [] }
}) => {
  return (
    <div>
      <h2>{summary.header}</h2>

      <TextContent {...summary} />

      <h4 className="mb-4">Months of Supply</h4>
      <p>
        The Months of Supply housing metric is an estimate of how long it would
        take to sell all the homes for sale relative to the number of homes sold
        each month. Historically, 5 to 6 months is the average. You may also
        hear this metric referred to as the &quot;absorption rate.&quot;
      </p>
      <p>
        Lower months of housing supply typically signal a seller’s market
        whereas when months of supply is greater than 6 months typically signal
        a buyer’s market.
      </p>

      <h4 className="mb-4">Sales to Listing Ratio</h4>
      <p>
        Sales to Listing Ratios are an indicator of supply and demand. It is all
        the completed sales in the past month divided by the total number of
        active listings.
      </p>
      <p>
        In a balanced real estate market, the total number of home sales to
        active listings ratio is between 0.12 and 0.2 while markets with a ratio
        higher than 0.2 favors seller’s, as homes are selling fast and there is
        limited inventory, while markets below 0.12 favor home buyers because
        there is a larger supply of homes to purchase.
      </p>

      <h3>Selling a house in {geo}</h3>
      <TextContent {...sellerText} />

      <h3>Buying a house in {geo}</h3>
      <TextContent {...buyerText} />
    </div>
  )
}

export default BuyerSeller
